module.exports = __webpack_public_path__ + "img/login_img.d0e52f27.jpg";